import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_PROFISSOES_BOX = "getProfissoesBox";

const state = {};

const getters = {};

const actions = {
    [GET_PROFISSOES_BOX](context, filtros) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("profissoesBox", filtros).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

const mutations = {};

export default {
    state,
    actions,
    mutations,
    getters
};